import styled from "@rentiohq/web-theme";

/* Establishes a query container so the card responds to its OWN width
   (it lives in a resizable column), not the viewport width. */
export const Root = styled.div`
  container-type: inline-size;
  margin-bottom: 16px;
  @media (min-width: 52em) {
    margin-bottom: 24px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  height: 72px;
  padding: 17px 24px;
  border-radius: 4px;
  border: 1px solid rgba(15, 143, 110, 0.1);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  background-image: linear-gradient(
      90deg,
      rgba(15, 143, 110, 0.1) 0%,
      rgba(15, 143, 110, 0.1) 100%
    ),
    linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%);

  /* Not enough room for a single row: stack into two rows
     (title + toggle on top, funnel below). */
  @container (max-width: 800px) {
    flex-wrap: wrap;
    height: auto;
    min-height: 72px;
    row-gap: 14px;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding-right: 25px;
  white-space: nowrap;

  @container (max-width: 800px) {
    /* Grow to push the publication toggle to the far right of row 1. */
    flex: 1 1 auto;
    padding-right: 16px;
  }
`;

export const FunnelWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  @container (max-width: 800px) {
    /* Move to its own full-width row below the title + toggle. */
    order: 1;
    flex-basis: 100%;
    height: auto;
  }
`;

export const PipelineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 400px; /* Constrain width so bubbles don't spread too far */

  @container (max-width: 800px) {
    /* Stacked on its own row: let the bubbles span the full block width. */
    max-width: none;
  }
`;

export const StepItemWrap = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

export const LineLeft = styled.div<{ isActive: boolean }>`
  position: absolute;
  left: 0;
  top: 50%;
  width: 50%;
  height: 2px;
  margin-top: -1px;
  background-color: ${props =>
    props.isActive ? props.theme.colors.green60 : props.theme.colors.neutral30};
  z-index: -1;
`;

export const LineRight = styled.div<{ isActive: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 50%;
  height: 2px;
  margin-top: -1px;
  background-color: ${props =>
    props.isActive ? props.theme.colors.green60 : props.theme.colors.neutral30};
  z-index: -1;
`;

export const StepBubble = styled.div<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  font-weight: bold;
  font-size: 14px;
  color: ${props =>
    props.isActive ? props.theme.colors.green60 : props.theme.colors.neutral30};
  border-color: ${props =>
    props.isActive ? props.theme.colors.green60 : props.theme.colors.neutral30};
  background-color: white;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.1s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;

export const PublicationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @container (max-width: 800px) {
    flex: 0 0 auto;
  }
`;
